import React, { useState, useRef } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { RoutePaths } from "../../components/Routes";
import AuthService from "../../services/Auth";
import SnackbarWrapper from "../../components/SnackbarWrapper";
import {
  Button,
  CssBaseline,
  FormControl,
  Input,
  InputLabel,
  Grow,
  Paper,
  Typography,
} from "@mui/material";
import { GrowMessage } from "../../components/GrowMessage";

let authService = new AuthService();
//let authStyle = require('../../styles/auth.styl');

const SignIn = () => {
  const [state, setState] = useState({
    initialLoad: true,
    error: null as string | null,
    showMessage: false,
    message: "",
  });

  const emailInput = useRef<HTMLInputElement>(null);
  const passwordInput = useRef<HTMLInputElement>(null);

  const navigate = useNavigate();
  const location = useLocation();

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    authService
      .signIn(emailInput.current?.value, passwordInput.current?.value)
      .then((response) => {
        if (!response.is_error) {
          let redirect =
            location.state &&
            location.state.from &&
            location.state.from.pathname !== "/Logout"
              ? `${location.state.from.pathname}${location.state.from.search}`
              : RoutePaths.CurrentEvents;
          navigate(redirect);
        } else {
          setState({
            ...state,
            message: response.error_content.error,
            showMessage: true,
          });
        }
      })
      .catch((response) => {
        setState({
          ...state,
          message: response.error_content,
          showMessage: true,
        });
      });
  };

  const handleSnackbarClose = (event: any, reason: string) => {
    if (reason === "clickaway") return;
    setState({ ...state, showMessage: false });
  };

  const search = location.search;
  const params = new URLSearchParams(search);

  return (
    <main className="offset-lg-3 offset-md-3 offset-sm-3 col-lg-6 col-md-6 col-sm-6 col-xs-12">
      <CssBaseline />
      <Typography component="h1" variant="h5">
        BMW - Veranstaltungen Login
      </Typography>
      <form className="form" onSubmit={handleSubmit}>
        <FormControl margin="normal" required fullWidth>
          <InputLabel htmlFor="email">Username</InputLabel>
          <Input
            inputRef={emailInput}
            id="email"
            name="email"
            autoComplete="email"
            autoFocus
          />
        </FormControl>
        <FormControl margin="normal" required fullWidth>
          <InputLabel htmlFor="password">Passwort</InputLabel>
          <Input
            inputRef={passwordInput}
            name="password"
            type="password"
            id="password"
            autoComplete="current-password"
          />
        </FormControl>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          className="btnBlue"
        >
          Anmelden
        </Button>
      </form>
      <div className="mt-3 text-center">
        <Link to="/forgottenpassword">Passwort zurücksetzen</Link>
      </div>
      <GrowMessage
        message={state.message}
        visible={state.showMessage}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
      ></GrowMessage>
    </main>
  );
};

export default SignIn;
